import Mustache from 'mustache';
import { csrfToken, setReplaceSvg, imgPreload } from '@/js/_common';
import jobCardHtml from '@/js/html_templates/job-card.html';
import { setEvent as setFavoriteEvent } from '@/js/_components/parts/favorite';

const loadData = async (path, page, cond) => {
    const params = new URLSearchParams();
    params.append('page', page);
    for (const [key, value] of Object.entries(cond)) {
        if (value) {
            params.append(key, value);
        }
    }

    return await fetch(`${path}?${params.toString()}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken
        },
    })
        .then(response => response.json());
}

export const loadMore = async (targetSelector= '.c-lists-job', fetchUrl = '/api/user/job/list') => {
    const moreBtn = document.querySelector('.more');
    const jobList = document.querySelector(targetSelector);

    console.log(jobList.dataset.lastPage, jobList.dataset.page)
    if (jobList.dataset.lastPage == jobList.dataset.page){
        document.querySelector('.c-lists-job__loading').remove();
        return;
    }

    const params = JSON.parse(jobList.dataset.params || '{}');
    const page = Number(jobList.dataset.page) + 1;
    const resp = await loadData(fetchUrl, page, params);
    jobList.dataset.page = resp.job_list.current_page;
    let imgList = [];
    resp.job_list.data.forEach(job => {
        const html = Mustache.render(jobCardHtml, {
            ...job,
            is_favorite: job.is_favorite ? 1 : 0,
            is_closed: job.is_closed ? 'true' : '',
            tags: (job.display_tags || []).join(', '),
        });
        jobList.querySelector('.c-lists-job__items').insertAdjacentHTML('beforeend', html);

        const articleObj = jobList.querySelector(`.c-lists-job__items article[data-job-id="${job.id}"]`);
        if (!articleObj) return;
        const favoriteObj = articleObj.querySelector('.c-parts-favorite')
        if (!favoriteObj) return;
        setFavoriteEvent(favoriteObj);
        imgList.push(job.thumbnail_url);
    });
    setReplaceSvg('.c-lists-job__items');
    await imgPreload(imgList);
    jobList.querySelectorAll('.c-cards-job').forEach(card => {
        card.classList.remove('is-loading');
    });

    const searchParams = new URLSearchParams(location.search.replace(/^\?/, ''));
    let queryEntries = searchParams.entries();
    let queryParamsObject = Object.fromEntries(queryEntries);
    queryParamsObject = {...queryParamsObject, page};
    history.replaceState('', '', `${location.pathname}?${new URLSearchParams(queryParamsObject).toString()}`);
}

const main = () => {
    if (document.querySelector('#page-user-job') == null) return;

    const scrollIo = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            loadMore();
        }
    });
    if(document.querySelector('.c-lists-job__loading')){
        scrollIo.observe(document.querySelector('.c-lists-job__loading'));
    }
}

export default main;
